import { qualityAssuranceSerialiser } from './qualityAsssurance';

const serialiseVideoPendingApproval = (video) => ({
  ...video,
  comments: video.comments,
  contentLength: video.content_length,
  key: video.key,
  lastModified: video.last_modified,
  matchId: video.match_id,
  matchPart: video.match_part,
  matchVideoAlreadyExists: video.match_video_already_exists,
  presignedUrl: video.presigned_url,
  qAStatus: video.qa_status,
  qualityAssuranceInfo: qualityAssuranceSerialiser(
    video.quality_assurance_info,
  ),
  sport: video.sport,
  track: video.track,
  uploadedBy: video.uploaded_by,
  version: video.version,
});

export const videosPendingApprovalSerialiser = (videoListings) =>
  videoListings?.map(serialiseVideoPendingApproval);

export default { videosPendingApprovalSerialiser };
